import {OrderTrackerOrder} from '../types';

export const keepOrderByTTL = (
  now: number,
  order: OrderTrackerOrder,
  ttlMs: number,
) => {
  if (!order.isReady) {
    return true;
  }
  const seenAt = order.readySeenAt ?? now;
  return now - seenAt <= ttlMs;
};
